/**
 * Trạng thái lệnh chuyển tiền — MISA Panda x Jetpay BankHub
 */
const JetpayTransferStatus = Object.freeze({
  KeToanVienRecalled: 0,               // KTV thu hồi
  PendingChiefAccountantApproval: 1,   // Chờ KTT duyệt
  ChiefAccountantRejected: 2,          // KTT từ chối
  ChiefAccountantRecalled: 3,          // KTT thu hồi
  PendingHeadApproval: 4,              // Chờ thủ trưởng duyệt
  HeadRejected: 5,                     // Thủ trưởng từ chối
  BankProcessing: 6,                   // NH đang xử lý
  Expired: 7,                          // Hết hạn giao dịch
  Transferred: 8,                      // Đã chuyển tiền
  BankRejected: 9,                     // NH từ chối giao dịch
  TransferFailed: 10,                  // Chuyển khoản thất bại
});

const JetpayTransferStatusLabel = {
  [JetpayTransferStatus.KeToanVienRecalled]: 'KTV thu hồi',
  [JetpayTransferStatus.PendingChiefAccountantApproval]: 'Chờ KTT duyệt',
  [JetpayTransferStatus.ChiefAccountantRejected]: 'KTT từ chối',
  [JetpayTransferStatus.ChiefAccountantRecalled]: 'KTT thu hồi',
  [JetpayTransferStatus.PendingHeadApproval]: 'Chờ thủ trưởng duyệt',
  [JetpayTransferStatus.HeadRejected]: 'Thủ trưởng từ chối',
  [JetpayTransferStatus.BankProcessing]: 'NH đang xử lý',
  [JetpayTransferStatus.Expired]: 'Hết hạn',
  [JetpayTransferStatus.Transferred]: 'Đã chuyển tiền',
  [JetpayTransferStatus.BankRejected]: 'NH từ chối',
  [JetpayTransferStatus.TransferFailed]: 'Chuyển khoản thất bại',
};

const JetpayTransferStatusOptions = Object.entries(JetpayTransferStatusLabel).map(([value, text]) => ({
  value: Number(value),
  text,
}));

export default {
  JetpayTransferStatus,
  JetpayTransferStatusLabel,
  JetpayTransferStatusOptions,
};
